import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { TermsStorage } from './terms-storage';
import { TermsPopupComponent } from './terms-popup.component';
import { GlobalPopupModule } from '../global-popup/global-popup.module';
import { TermsAcceptanceStorage } from './terms-acceptance-storage';
import { UserAcceptedTermsGuard } from './user-accepted-terms-guard';
import { AcceptTermsPageComponent } from './accept-terms-page.component';
import { OsrDisclaimerComponent } from './osr-disclaimer.component';
import { KitDisclaimerComponent } from './kit-disclaimer.component';
import { PortalDisclaimerPopupComponent } from './portal-disclaimer-popup.component';

@NgModule({
    imports: [SharedModule, GlobalPopupModule],
    providers: [TermsStorage, TermsAcceptanceStorage, UserAcceptedTermsGuard],
    declarations: [TermsPopupComponent, AcceptTermsPageComponent, OsrDisclaimerComponent, KitDisclaimerComponent, PortalDisclaimerPopupComponent],
    exports: [OsrDisclaimerComponent, KitDisclaimerComponent]
})
export class CorporateModule {

}